<script>
import { Label, Icon } from '@smui/common'
import IconButton from '@smui/icon-button';
import Tooltip, { Content, Wrapper, Link, RichActions } from '@smui/tooltip';
import Line from "svelte-chartjs/src/Line.svelte"
import { Chart } from 'chart.js';

// import * as ChartAnnotation from 'chartjs-plugin-annotation';
import annotationPlugin from 'chartjs-plugin-annotation';

export let title = "..."
export let mdIcon = "directions_bike"
export let subtitle = "Total cycle hire trips for each year by city"
export let subnote = ""
export let show2021 = true
export let showWeekdaysEnds = false
export let chartData = {}
export let chartOptions = {}
export let popupInfo = {}

console.log("chartData", title, chartData)

let baseChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    display: false,
    labels: {
      fontColor: "#eee",
      fontSize: 16,
    }
  },
  scales: {
    xAxes: [{
      gridLines: {
        drawBorder: false,
        display: false,
        color: "rgba(0, 0, 0, 0)",
      },
      ticks: {
        precision: 0,
        display: false //this will remove only the label
      }
    }],
    yAxes: [{
      gridLines: {
        drawBorder: false,
        display: false,
        color: "rgba(0, 0, 0, 0)",
      },
      ticks: {
        precision: 0,
        display: false //this will remove only the label
      }
    }]
  },
  title: {
    display: false,
  }
}

</script>
	<section>
		<div class="section-body">
			<h2 class="ioreveal animate__animated" style="margin: 10px 0 20px 0" data-anicss="animate__fadeInDown">
      <span class="material-icons">{mdIcon}</span>
      { title }
      </h2>
      <h4 style="margin-bottom: 10px">{subtitle}
      {#if (subnote)}
      <span style="font-style: italic; opacity:0.8; font-size: 11px; margin: 8px 0 0 0; display: block">{subnote}</span>
      {/if}
      </h4>
      <div class="ioreveal animate__animated animate__delay-3s chart-key" data-anicss="animate__fadeIn" style="animation-delay: .5s;">
        <div class="yr-2019"><span class="bgcolor-2019"></span> 2019</div>
        <div class="yr-2020"><span class="bgcolor-2020"></span> 2020</div>

        {#if (show2021)}
        <div class="yr-2021"><span class="bgcolor-2021"></span> 2021</div>
        {/if}
      </div>
      <div class="row ioreveal animate__animated" data-anicss="animate__fadeIn">
      {#each chartData as provider}
        <div
          class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6"
          style="max-height:135px; margin-bottom: 45px; padding-right: 40px; padding-left: 40px">
          <div style="margin-top: 0; position: relative">
            {provider.name}, {provider.city}
            {#if (provider.city === 'Portland')}
            <span style="color:rgba(255,255,255, 0.6);font-style:italic;font-size:12px">2020 Jan-Aug</span>
            {/if}
            <!-- <Wrapper rich style="display:inline-block;height: 40px;">
              <IconButton touch
                style="margin-left: -10px;"
                class="material-icons"
                on:click={() => 1 + 1}>info</IconButton>
              <Tooltip>
                <Content>
                  {popupInfo[provider.id] ? popupInfo[provider.id].info : '??'}
                </Content>
              </Tooltip>
            </Wrapper> -->

            <div class="arrow-changea">
              <!-- <span>44%</span>
              <Icon class="material-icons" style="display:inline-block;font-size: 20px;margin-left: -3px;">arrow_upward</Icon> -->
              <!-- <span>{ Math.abs(provider.percentDiff) }</span>%
                {#if provider.arrowUp}
              <Icon class="material-icons" style="display:inline-block;margin-left: 2px;">arrow_upward</Icon>
              {:else}
              <Icon class="material-icons" style="display:inline-block;margin-left: 2px;">arrow_downward</Icon>
              {/if}             -->
            </div>
          </div>
          <Line data={provider.data} options={{ ...baseChartOptions, ...chartOptions }}/>
        </div>
      {/each}
      </div>

		</div>
	</section>

<style>
.row {
  /* margin-bottom: 112px; */
  font-size: 1.1rem;
  padding: 10px 0;
}
/* .row:nth-child(odd) {
  background-color: rgba(0,0,0,0.2);
} */
.section-body {
  /* max-width: 960px;
  padding: 30px;
  margin: auto; */
  /* margin-left: 200px; */
  /* text-align: left; */
}
.statistic-num {
  font-size: 2.2rem;
}
.provider-name {
  margin-top: 8px;
  text-align: right;
}

.arrow-change2 {
  display:inline-block;
  /* color: white;
  background: #ee3311; */
  color: red;
  border: red;
  background: rgba(255,255,255,0.8);
  border-radius: 5px;
  padding: 2px 2px;
  font-size: 1rem;
  margin-left: 10px;
  position: absolute;
  right: 0;
  top: -10px;
  /* border-radius: 50%;
  background: #ff3344; */
}

.arrow-change {
  display: inline-block;
  background: rgba(255,0,10,.8);
  padding: 3px;
  font-size: 0.9rem;
  border-radius: 10px;
}
.chart-key {
  margin-bottom: 12px;
}
.chart-key > div {
  display: inline-block;
  margin-right: 12px;
}
.chart-key > div > span {
  width: 15px;
  min-height: 15px;
  height: 100%;
  /* background-color: var(--year-title-2019); */
  content: "";
  position:relative;
  display:inline-block;
}



</style>